import { testIsUndefined, testObjectHasKey } from '../../lib/test-and-assert/test-base';
import { createSatApi } from '../api/api';
import { Uploader } from './core/uploader';
import { assertIsNonEmptyString } from '../../lib/test-and-assert/assert-base';

if (testIsUndefined(window.globalUploaders)) {
    window.globalUploaders = {};
}

/** @type {Object} */
const globalUploaders = window.globalUploaders;

/**
 * Creates a new uploader. if no name is given then the name is set to default
 *
 * If an uploader already exists with a given name then it is returned
 *
 * @param {Object} config
 * @param {ApiConfig} apiConfig
 * @param {String} [name='default']
 *
 * @return {Uploader}
 */
function createGlobalUploader(config, apiConfig, name) {
    if (testObjectHasKey(globalUploaders, name)) {
        return globalUploaders[name];
    }

    if (testIsUndefined(name)) {
        name = 'default';
    }

    const api = createSatApi(apiConfig);

    globalUploaders[name] = new Uploader(api, config);

    return globalUploaders[name];
}

/**
 * Returns an uploader with a given name. If no uploader exists then null is returned
 *
 * @param {String} [name='default']
 *
 * @return {?Uploader}
 */
function getGlobalUploader(name) {
    if (testIsUndefined(name)) {
        name = 'default';
    }

    assertIsNonEmptyString(name);

    if (testObjectHasKey(globalUploaders, name)) {
        return globalUploaders[name];
    }

    return null;
}

export { createGlobalUploader };
export { getGlobalUploader };
